export class StateSigningRequirementsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getStateSigningRequirements(params) {
    return this.#http.get('/api/state-signing-requirements', { params });
  }
}
